/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useListDeploymentsQuery } from '@modules/cloud-lib/deployments/hooks'
import usePermissions from '@modules/permissions-lib/hooks'

import type { UseQueryOptions } from 'react-query'
import type { ResourceQueryResult } from '../types'

export const useResourcesQuery = (
  options?: Pick<UseQueryOptions, 'enabled'>,
): ResourceQueryResult => {
  const enabled = options?.enabled ?? true

  const showDeployments = usePermissions([{ type: 'deployment', action: 'list' }], 'every', {
    enabled,
  }).hasPermissions

  const deploymentQuery = useListDeploymentsQuery({
    enabled: showDeployments,
  })

  return {
    resourceType: 'deployment',
    data: deploymentQuery.data?.deployments,
    isLoading: deploymentQuery.isLoading,
    error: deploymentQuery.error,
    isEnabled: showDeployments,
  }
}
